export const companyInformation = {
  acronym: 'AS',
  name: 'Anonymous Systems',
  short_name: 'AnonSys',
  title: 'Technology Website',
  byline: 'Software development company based in Michigan.',
  email: 'info@anonsys.tech',
  business: {
    hours: 'Monday - Friday: 9:00 - 19:00',
    telephone: '(+612) 253 5600',
    address: 'PO Box 1622 Colins Street West Victoria 8077 Australia'
  },
  socials: {
    instagram: '#',
    facebook: '#',
    twitter: '@anonsystech',
    etsy: '#'
  }
}

export const developerInformation = {
  name: 'Anonymous One',
}
